import { ViewColumn } from '@mui/icons-material';
import { IconButton, Menu } from '@mui/material';
import { GridColumnGroupingModel } from '@mui/x-data-grid-premium';
import { GridApiPremium } from '@mui/x-data-grid-premium/models/gridApiPremium';
import { MutableRefObject } from 'react';

import { GroupColumnsPanelContent } from '~/components/SolaForceDataGrid';
import { useMenuButton } from '~/hooks/useMenu';
import { useSxStyles } from '~/scenes/PortalModules/Analytics/common/ReportColumnsVisibility/useStyles';

type PropsType = {
  apiRef: MutableRefObject<GridApiPremium | null>;
  columnGroupingModel?: GridColumnGroupingModel;
  isLoading?: boolean;
};

export const ReportColumnsVisibility = (props: PropsType) => {
  const { apiRef, columnGroupingModel, isLoading } = props;

  const sxStyles = useSxStyles();

  const { isOpen, open, close, anchorEl } = useMenuButton();

  return (
    <>
      <IconButton
        id={'report-export-button'}
        aria-controls={isOpen ? 'basic-menu' : undefined}
        aria-haspopup={'true'}
        aria-expanded={isOpen ? 'true' : undefined}
        disabled={isLoading || !apiRef.current}
        onClick={open}
      >
        <ViewColumn />
      </IconButton>
      <Menu
        id={'report-export-menu'}
        anchorEl={anchorEl}
        open={isOpen}
        onClose={close}
        slotProps={{
          list: {
            'aria-labelledby': 'report-export-button',
            sx: sxStyles.menu,
            component: 'div',
          },
        }}
      >
        {!!apiRef.current && (
          <GroupColumnsPanelContent
            apiRef={apiRef as MutableRefObject<GridApiPremium>}
            columnGroupingModel={columnGroupingModel}
            sx={sxStyles.columnsPanel}
          />
        )}
      </Menu>
    </>
  );
};
